import Text from 'components/Text/Text';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CreateButton.module.scss';

const CreateBtn: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<IScheduleViewContext>(ScheduleViewContext);

	const handleRedirect = () => {
		changeTypeOfModalWindow('createSchedule');
	};

	return (
		<Button
			className={style.btn}
			theme="primaryBlue"
			data-test="CreateBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleRedirect}>
			<Text translationNameSpace="form" translationKey="createScheduleButton" asFragment={true} />
		</Button>
	);
};

export default CreateBtn;
